import { FilePenLine, ChevronDown, Dot } from 'lucide-react';
import { useState } from 'react';
import { uniqueId } from 'lodash';

import { Button } from '@/components/ui/button';
import { Badge, BadgeProps } from '@/components/ui/badge';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { cn } from 'src/lib/utils';

type Props = {
  items: {
    label: string;
    value: string;
    children?: {
      label: string;
      value: string;
    }[];
    badge?: {
      label: string;
      variant: BadgeProps['variant'];
    };
  }[];
  className?: string;
  defaultOpen?: boolean;
};

const SuggestedChangesView = ({ items, className, defaultOpen = false }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  if (!items.length) return null;

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className={cn('bg-orange-50 rounded-md overflow-hidden', className)}
    >
      <CollapsibleTrigger asChild>
        <Button
          variant="ghost"
          className="relative justify-start w-full text-orange-800! hover:bg-orange-500/10 font-bold px-5"
        >
          <FilePenLine />
          Suggested changes
          <ChevronDown className={cn('absolute right-5 size-4 transition-transform', isOpen && 'rotate-180')} />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="pb-4 px-5">
        <div className="space-y-1 text-sm px-5 opacity-70">
          {items.map(({ label, value, children, badge }) => (
            <div key={uniqueId('suggested-changes-')} className="flex items-start text-orange-800 gap-1">
              <Dot className="size-5 shrink-0" />
              <div className="space-y-0.5 grow min-w-0">
                <div className="flex-1 wrap-break-word">
                  <strong>{label}:</strong>
                  {children && <br />}
                  <span> {value}</span>
                  {children && (
                    <ul>
                      {children.map(({ label, value }) => (
                        <li key={uniqueId('suggested-changes-child-')}>
                          <span className="underline">{label}:</span>
                          <span> {value}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {badge && <Badge variant={badge.variant}>{badge.label}</Badge>}
              </div>
            </div>
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
export default SuggestedChangesView;
